import { render, staticRenderFns } from "./NearbyServicesButton.vue?vue&type=template&id=2d98d824&scoped=true"
import script from "./NearbyServicesButton.vue?vue&type=script&lang=js"
export * from "./NearbyServicesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d98d824",
  null
  
)

export default component.exports